import React from "react";
import ProfileSettings from "../../views/ProfileSettings";

const ProfileSettingsPage = () => {
  return <ProfileSettings />;
};

export default ProfileSettingsPage;
